import { applyPrintPaper, clearPrintPaper, getPaperSize } from '../../../utils/printPaper'

export const PRINT_ROOT_ID = 'cycle-document-print-root'
export const PRINT_BODY_CLASS = 'printing-cycle-document'

/** Create the print root under <body> and tag <body>; returns the root element. */
export function beginDocumentPrint(language) {
  let root = document.getElementById(PRINT_ROOT_ID)
  if (!root) {
    root = document.createElement('div')
    root.id = PRINT_ROOT_ID
    document.body.appendChild(root)
  }
  const paper = getPaperSize(language)
  document.body.classList.add(PRINT_BODY_CLASS)
  document.body.setAttribute('data-print-paper', paper)
  applyPrintPaper(paper)
  return root
}

/** Undo beginDocumentPrint. */
export function endDocumentPrint() {
  document.body.classList.remove(PRINT_BODY_CLASS)
  document.body.removeAttribute('data-print-paper')
  clearPrintPaper()
  document.getElementById(PRINT_ROOT_ID)?.remove()
}
